<template>
    <section class="login">
        <md-layout md-gutter class="md-whiteframe md-whiteframe-5dp login-doctor login-wrap" v-if="lang">
            <md-layout md-flex-xsmall="100" md-flex-small="50" class="bg bg--brand">
                <div class="login--bg">
                    <img loading="lazy" src="../../assets/img/login_doctor_image.jpg" alt="">
                </div>
                <md-layout md-column md-gutter>
                    <md-layout md-flex="50"></md-layout>
                    <md-layout>
                        <div class="login--brand">
                            <h1 class="md-display-2">{{ translate.pages.login.subtitle }}</h1>
                            <p class="md-body-2 summary">{{ translate.pages.login.description }}</p>
                            <md-button class="md-raised md-primary has-ripple btn--green md-size" @click.native="$router.push({'name':'register.doctor'})">
                              <!-- {{ translate.actions.register }} -->
                              Registrarse
                            </md-button>
                        </div>
                    </md-layout>
                </md-layout>
            </md-layout>
            <md-layout md-flex-xsmall="100" md-flex-small="50" class="login--wrap">
                    <md-layout md-flex="100" md-align="center">
                        <div class="figure login--logo">
                            <figure>
                                <img  loading="lazy" src="../../assets/img/amol1.png" alt="logo">
                            </figure>
                        </div>
                    </md-layout>
                    <md-layout md-flex="100">
                        <div class="row contain login--form">
                            <form novalidate @submit.prevent="submit('form-login')" data-vv-scope="form-login">
                                <md-input-container :class="{ 'md-input-invalid' : _errors.has('form-login.rut')}">
                                    <md-icon>perm_identity</md-icon>
                                    <label>{{ translate.pages.login.fields.code }}</label>
                                    <md-input type="text" v-model="data.rut"
                                        v-validate
                                        data-vv-name="rut"
                                        data-vv-rules="required|usercode"></md-input>
                                    <span class="md-error">{{ _errors.first('form-login.rut') }}</span>
                                </md-input-container>
                                <md-input-container :class="{ 'md-input-invalid' : _errors.has('form-login.password') }">
                                    <md-icon>lock_outline</md-icon>
                                    <label>{{ translate.pages.login.fields.password }}</label>
                                    <md-input type="password" v-model="data.password"
                                        v-validate
                                        data-vv-name="password"
                                        data-vv-rules="required"></md-input>
                                    <span class="md-error">{{ _errors.first('form-login.password') }}</span>
                                </md-input-container>
                                <p v-if="errors.response.invalid" class="error-response">{{ errors.response.msg }}</p>
                                <md-button type="submit" class="md-raised md-primary w100 md-size" :disabled="process">{{ translate.actions.login }}</md-button>
                                <!-- TODO: Recovery password -->
                                 <div class="recovery" @click="goRecovery()">
                                    <span>Recuperar</span>
                                    <span class="password">Contraseña</span>
                                </div>
                            </form>
                        </div>
                    </md-layout>
                    <md-layout md-flex="100">
                        <div class="row contain language--box login--language" style="margin-top: 15px">
                            <md-layout md-gutter md-align="end">
                                <span class="language"><md-icon>language</md-icon></span>
                                <md-select name="language" id="language" v-model="lang" @change="updateLang">
                                    <md-option :value="language.code" v-for="language in languages" :key="language.id">{{ language.name }}</md-option>
                                </md-select>
                            </md-layout>
                        </div>
                    </md-layout>
                    <div class="login--select">
                        <md-menu class="login-menu">
                            <md-button md-menu-trigger class="login--btn">
                                {{ data.type.value }} <md-icon>keyboard_arrow_down</md-icon>
                            </md-button>
                            <md-menu-content>
                                <md-menu-item v-for="item in types"
                                    :key="item.name"
                                    @selected="selectedItem($event,item)">{{ item.value }}
                                </md-menu-item>
                            </md-menu-content>
                        </md-menu>
                    </div>
            </md-layout>
        </md-layout>
    </section>
</template>

<script>
    import { login, doctor } from '../../config/api.js';
    import { mapActions } from 'vuex';
    import { validate_chile } from '../../config/validators.js';
    export default {
        created() {
            var self = this;
            if(!this.$store.getters.language.app){
                this.loadLanguage();
            }
            this.$validator.extend('usercode', {
                getMessage: function(field){
                    return field + ' no es valido.';
                },
                validate: function(value){
                    if(window.countryCODE == "cl"){
                        return validate_chile(value);
                    }
                    return true;
                }
            });
        },
        data() {
            return {
                data: {
                    'rut': '',
                    'password': '',
                    'type': {name:'healt_provider',value:'Prestador'},
                    'prefix': this.$route.params.country.toUpperCase()
                },
                'types': [
                    {name:'healt_provider',value:'Prestador'},
                    {name:'subordinate',value: 'Usuario'}
                ],
                process: false,
                errors: {
                    'response': {
                        'invalid': false,
                        'msg': '',
                    }
                },
                route: {
                    doctor : doctor,
                }
            }
        },
        computed: {
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get lang
            lang(){
                return this.$store.getters.language.lang;
            },
            // Get Languages
            languages() {
                return this.$store.getters.language.languages;
            }
        },
        methods: {
            goRecovery(){
                this.$router.push("/"+window.countryCODE+'/recovery')
            },
            // Update Lang
            updateLang(lang){
                this.$store.dispatch('setLang', lang);
                this.$lang.setLanguage(lang);
            },
            // Submit login
            submit(scope){
                var self = this;
                this.$validator.validateAll(scope)
                    .then(function(result) {
                        if (result) {
                            self.process = true;
                            self.data.lang = self.lang;
                            self.$http.post('login', self.data)
                                .then(function(response){
                                    self.process = false;
                                    let data = response.data.data;
                                    self.$auth.setToken(data.access_token, (data.expires_in + parseInt(Date.now()/1000)));
                                    if(data.user.type == 'healt_provider'){
                                        // self.$router.push({'name': 'Office'});
                                      window.location.href = window.location.href
                                    }else{
                                        // self.$router.push({'name': 'Doctor'});
                                      window.location.href = window.location.href

                                    }
                                }).catch(function(error){
                                    self.process = false;
                                    if (error.response) {
                                        let data = error.response.data;
                                        if(error.response.status === 422)
                                        {
                                            for(var index in data)
                                            {
                                                var messages = '';
                                                data[index].forEach( function(item){ messages += item + ' '});
                                                self.errors.errors.unshift({
                                                    field: index,
                                                    msg: messages,
                                                    scope: scope
                                                });
                                            }
                                        }else if(error.response.status === 401){
                                            self.errors.response.invalid = true;
                                            self.errors.response.msg = "Datos incorrectos";
                                        }else{
                                            console.log(error);
                                            alert("Error generic");
                                        }
                                    } else if (error.request) {
                                        console.log(error.request);
                                        alert("Error empty");
                                    } else {
                                        console.log('Error', error.message);
                                        alert("Error");
                                    }
                                });
                        }
                    });
            },
            // Selecteditem
            selectedItem($event,type){
                this.data.type = type;
            },
            // LoadLanguage
            ...mapActions({
                fetchLanguage: 'loadLanguage'
            }),
            // Load Language from actions
            loadLanguage() {
                this.fetchLanguage();
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import '../../assets/styles/variables/color.styl'
    .hidden
        display none!important
    h1
        margin 0 0 0 0
        color white !important
    .bg
        overflow hidden
        // background-image url('../../assets/img/login_doctor.jpg')
        // background-repeat no-repeat
        // background-position center center
        // background-size 100% 100%
        border-radius .5em 0 0 0.5em
    .bg--brand
        position relative
        max-width 380px
        &:after
            content ''
            display block
            position absolute
            z-index -1
            height 100%
            width 100%
            background rgba(5,26,50,0.48)

        .login--bg
            z-index -1
            position absolute
            top 0
            left 0
            width 100%
            height 100%
            overflow hidden
            img
                margin auto
                position absolute
                top -5px
                left -140px
                max-width none
                min-height 100%
                width auto
                min-width 100%

    .btnRegister
        margin-left 0.25em
        padding 0.5em 2em
        background-color #0571BE !important
        color white !important
    .container
        margin-left 3em
        margin-right 3em
    .error-response
        text-align center
        color color_error
    .figure
        display flex
        justify-content center
        align-items center
    .language
        line-height 32px
        padding-right .5em

    .login
        align-items center
        display flex
        justify-content center
        min-height 100vh
        background login_background
        .login--wrap
            padding-bottom 30px
        .login-wrap
            box-shadow 0 5px 12px rgba(0,0,0,0.12)
            background #FFF
            width 85%
            max-width 850px

        .login--logo
            width 100%
            text-align center
            padding-top 50px
            padding-bottom 30px
            figure
                margin 0
                width 100%
            img
                margin 0 auto
                height auto
                display block
                width 80%
                max-width 248px

     /* BRANDING
     -----------------------------------------*/
    .login--brand
        position absolute
        left 40px
        bottom 80px
        h1
            margin 0
            font-size 42px
            font-weight 500
            letter-spacing -0.02em
        p
            font-size 18px
            font-weight 400
            margin 5px 0 25px 0
        .md-button
            margin 0

    /* LOGIN FORM
     -----------------------------------------*/
    .login--form
        .md-button
            margin 38px 0 0 0

    .login-doctor
        border-radius .5em
    .md-select
        min-width auto
        width auto
    .password
        font-weight bold
    .recovery
        cursor pointer
        text-decoration underline
        margin 25px 0 10px
        color #4b6c8b
    .row
        display block
        width 100%
    .summary
        color white
    .language--box
        color #757e80
        font-size 13px
        .md-icon
            font-size 22px
            min-width 22px
            width 22px
    .w100
        width 100%
        background-color color_main !important

    @import '../../assets/styles/responsive.styl'
    @media (max-width: 370px)
        .login--brand
            padding-top 0!important
        .md-layout.bg.bg--brand.md-flex-xsmall-100.md-flex-small-50
            height 150px
        .figure.login--logo
            padding 35px 0 0px!important
        .md-input-container.md-theme-default
            margin-bottom 0!important
        section.login
            padding-top 5px!important
        p.error-response
            margin-bottom 5px!important
            margin-top 5px!important
        button.md-button.md-raised.md-primary.w100.md-size.md-theme-default
            margin-top 5px!important
        .row.container.language--box.login--language
            margin-top 5px!important
        .md-input-container.md-theme-default.md-has-value
            margin-top 15px!important
</style>
<style>
    .contain {
        margin-left: 3em !important;
        margin-right: 3em;
    }
</style>



// WEBPACK FOOTER //
// LoginDoctor.vue?39bf7bb4